export enum DEVICE_OPTIONS {
  mobile_useragent = 'mob-app',
}
